import {Link} from '@remix-run/react'
import {cva} from 'class-variance-authority'
import {forwardRef} from 'react'
import type {VariantProps} from 'class-variance-authority'
import type {ComponentProps} from 'react'

export const button = cva(
  'inline-flex justify-center items-center border border-transparent rounded-md font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      intent: {
        primary: `bg-primary-600 text-white hover:enabled:bg-primary-700 focus:ring-primary-500`,
        secondary: `bg-primary-100 text-primary-700 hover:enabled:bg-primary-200 focus:ring-primary-500`,
        danger: `bg-red-600 text-white hover:enabled:bg-red-700 focus:ring-red-500`,
        naked: `hover:text-gray-600 text-gray-500 shadow-none`,
      },
      size: {
        small: `px-2 py-1 text-xs leading-4`,
        medium: `px-4 py-2 text-sm`,
        large: `px-4 py-2 text-base`,
      },
    },
    compoundVariants: [
      {
        intent: 'primary',
        size: 'medium',
      },
    ],
    defaultVariants: {
      intent: 'primary',
      size: 'medium',
    },
  },
)

type ButtonProps = ComponentProps<'button'> & VariantProps<typeof button>

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button({className, intent, size, ...props}, ref) {
    return (
      <button
        ref={ref}
        className={button({intent, size, className})}
        {...props}
      />
    )
  },
)

export const LinkButton = ({
  className,
  intent,
  size,
  children,
  ...props
}: ComponentProps<typeof Link> & VariantProps<typeof button>) => (
  <Link className={button({intent, size, className})} {...props}>
    {children}
  </Link>
)
